import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Image,
    useMultiStyleConfig,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPDPath} from '../../../utils/custom-utils'

/**
 * Main Banner component
 *
 * @param {Object} - props.custom - Image Link.
 * @param {string} - props.text_subline - Sub Line.
 * @param {string} - props.text_headline - Head Line.
 * @returns {React.ReactElement} - main-Banner component.
 */
export const MainBanner = ({custom, heading, categoryTileUrl}) => {
    const imageURL = custom?.image?.disBaseLink
    const styles = useMultiStyleConfig('containerStyles')
    const {site, locale} = useMultiSite()
    const formattedTileUrl = getPDPath(categoryTileUrl, site, locale)

    return (
        <Box test-data-id={'main-banner'} {...styles.containerStyles} overflow={'hidden'}>
            <Link to={formattedTileUrl} position={'relative'} display="block">
                {imageURL && (
                    <Image
                        src={imageURL}
                        alt={'main-banner-image'}
                        filter="brightness(40%)"
                        height="43.75vw"
                        width="100%"
                        objectFit="cover"
                    />
                )}
                {heading && (
                    <Box
                        position={'absolute'}
                        top={'50%'}
                        transform={'translateY(-50%)'}
                        left={{base: '0', sm: '50px'}}
                        right={'0'}
                        textAlign={{base: 'center', sm: 'left'}}
                    >
                        <Box
                            dangerouslySetInnerHTML={{
                                __html: heading
                            }}
                            sx={{
                                fontSize: '28px',
                                lineHeight: '33.3px',
                                mb: '2',
                                fontWeight: 'medium',
                                color: 'white'
                            }}
                        />
                        <Text
                            fontSize="26px"
                            lineHeight="40px"
                            mb="4"
                            color="white"
                            textDecoration={'underline'}
                        >
                            <FormattedMessage defaultMessage="Shop Now" id="mainbanner.shop_now" />
                        </Text>
                    </Box>
                )}
            </Link>
        </Box>
    )
}

MainBanner.propTypes = {
    custom: PropTypes.object,
    heading: PropTypes.string,
    categoryTileUrl: PropTypes.string
}

export default MainBanner
